import * as React from "react";
import { styled, SxProps } from "@mui/material";
import "swiper/css";
import { useTranslation } from "react-i18next";

export type SliderPaginationProps = {
  sx?: SxProps;
  current: number;
  total: number;
};

const SliderPagination: React.FC<SliderPaginationProps> = (props) => {
  const { t } = useTranslation();
  const { current, total, ...otherProps } = props;

  return (
    <ProgressWrapper>
      <Progress current={current} total={total} {...otherProps} />
    </ProgressWrapper>
  );
};

export default SliderPagination;

const ProgressWrapper = styled("div")(({ theme }) => ({
  padding: `${theme.spacing(3)} 0 ${theme.spacing(7)}`,
  background: "radial-gradient(46.77% 100% at 50% 100.96%, rgba(255, 255, 255, 0.015) 0%, rgba(255, 255, 255, 0) 100%)",
}));

const Progress = styled("div")<Pick<SliderPaginationProps, "current" | "total">>(({ theme, current, total }) => ({
  position: "relative",
  margin: "0 auto",
  width: 792,
  height: 2,
  maxWidth: "100%",
  background: theme.palette.background[300],
  borderRadius: 4,
  overflow: "hidden",

  "&:before": {
    content: '""',
    position: "absolute",
    left: 0,
    width: `${100 / total}%`,
    transform: `translateX(${100 * current}%)`,
    transition: "transform  .4s ease-out",
    height: 2,
    background: theme.palette.grey[400],
  },
}));
